import { SectionHeader, Body } from "@sprout/typography";
import { PrimaryButton } from "@sprout/buttons";
import useTranslation from "@hooks/use_translation.ts";

interface Props {
  companyName: string;
  onClose: () => void;
}

export const ApplicationSuccess = ({ companyName, onClose }: Props) => {
  const { t } = useTranslation("jobSearch");
  return (
    <div className="flex flex-col items-center text-center gap-6 py-10 px-4">
      <SectionHeader>{t("applicationSuccess.header", { company: companyName })}</SectionHeader>
      <Body>{t("applicationSuccess.body")}</Body>
      <PrimaryButton onClick={onClose}>{t("applicationSuccess.back")}</PrimaryButton>
    </div>
  );
};
